export default "__VITE_ASSET__aPNQF$2k__"